import React from 'react';
import AvatarImage from '../../../elements/AvatarImage';
import moment from 'moment';

const ChatMessage = ({ direction, time, name, avatarUrl, text }) => {
  return (
    <div className={'chat-message ' + direction}>
      <span className="info">
        {moment(time).format('DD-MM-YYYY HH:MM')} - {name}
      </span>
      <div>
        <AvatarImage className="avatar" src={avatarUrl} alt="" height="64" width="64" />
        <p> {text} </p>
      </div>
    </div>
  );
};

export default ChatMessage;
